/**
 * created by lei lei on 2020/6/9
 * 135编辑器组件集成
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Col, Input, Row ,Upload, Icon, message} from "antd";
import './editor135.css'

const {TextArea} = Input;
function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 20;
    if (!isLt2M) {
        message.error('Image must smaller than 20MB!');
    }
    return isJpgOrPng && isLt2M;
}
export default class Editor135 extends Component {
    static defaultProps = {
        title:'',//标题
        summary:'',//摘要
        titlePic:'',//标题头图
        content:'',//135编辑器内容
        isUpdate:false,//是否更新子组件
    }
    static propTypes = {
        title:PropTypes.string.isRequired,//标题
        summary:PropTypes.string.isRequired,//摘要
        titlePic:PropTypes.string.isRequired,//标题头图
        content:PropTypes.string.isRequired,//135编辑器内容
        isUpdate:PropTypes.bool,//是否更新子组件
        clickFinishEdit:PropTypes.func.isRequired,//点击135编辑器完成按钮的回调方法
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            title:'',
            summary:'',
            titlePic:'',
            content:'',
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
        //塞入默认数据
      this.upDate135EditContent()
        if (window.addEventListener) {  // all browsers except IE before version 9
            window.addEventListener("message", this.onMessage, false);
        } else {
            if (window.attachEvent) {   // IE before version 9
                window.attachEvent("onmessage", this.onMessage);
            }
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.isUpdate){
            this.state.content=nextProps.content;
            this.upDate135EditContent()
            this.setState(nextProps)

        }
        //更新编辑器内容

    }
    componentWillUnmount() {
        //卸载监听
        window.removeEventListener('message', this.onMessage);
        this.setState = (state, callback) => {
            return;
        };
    }
    upDate135EditContent(){
        let editContent =this.state.content
        let editor135 = document.getElementById('editor135');

            setTimeout(function(){
                editor135.contentWindow.postMessage(editContent,'*');
            },1000);

    }

    onMessage = (e)=>{
        this.state.content=e.data;
        //e.data.source 是初始化的一堆东西。初始化生成135，组件相互连接的一堆东西，
        // 当用户时实点击135编辑器的完成编辑的按钮的时候，这时候是不存在e.data.source，
        // 这时候在去check 的时候就不存在135编辑器一直弹出message的问题，下面第一个判断是拦截编辑器初始化时候来回监听数据来回在编辑器与react 组件间的传输问题，
        // 解决来回弹出message 浏览器卡死问题。切勿删除

        if(!e.data.source){
            if(this.checkParams(this.state)){
                this.props.clickFinishEdit&&this.props.clickFinishEdit(this.state);
            }
        }

        this.setState({});
        // this.setState(prevState=>{
        //     let temState = Object.assign({}, prevState);
        //     temState.content = e.data;
        //     this.props.clickFinishEdit&&this.props.clickFinishEdit(temState);
        //     return prevState;
        // });

    };

    checkParams = (data) =>{
        if(!data.title){
            message.warn("请输入标题！");
            return false;
        }
        if(data.title.length > 64){
            message.warn("标题字数已超过64个字符！");
            return false;
        }
        if(!data.summary){
            message.warn("请输入摘要！");
            return false;
        }
        if(data.summary.length > 120){
            message.warn("摘要字数已超过120个字符！");
            return false;
        }
        if(!data.titlePic){
            message.warn("请输入标题图！");
            return false;
        }
        return true;
    };

    handleChange = info => {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // getBase64(info.file.originFileObj, titlePic =>
            //     this.setState({
            //         titlePic,
            //         loading: false,
            //     }),
            // );
            let fileInfo = info.file.response;
            console.log(fileInfo);
            this.setState({
                        titlePic : fileInfo.url,
                        loading: false,
                    })
        }
    };


    render() {
        const uploadButton = (
            <div>
               <Icon type={this.state.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">上传标题图</div>
            </div>
        );
        const { titlePic } = this.state;
        let protocol=window.location.protocol;//自动提取http或者https；
        return (
            <div className={'edit135'}>
                <table border={0} cellSpacing={0} cellPadding={0} width={"100%"} style={{height:"100vh"}}>
                    <tbody>
                        <tr><td height={198}>
                            <div style={{width:1100,display:'flex',paddingTop:20,paddingBottom:6,margin:'auto'}}>
                                <div style={{marginLeft:119}}>
                                    <Upload
                                        name="file"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action="/cm-sites-pms/ueditor/control?action=uploadimage"
                                        beforeUpload={beforeUpload}
                                        onChange={this.handleChange.bind(this)}
                                    >
                                        {titlePic ? <img src={titlePic} alt="avatar" style={{ maxWidth: '128px',maxHeight: '128px' }} /> : uploadButton}
                                    </Upload>
                                </div>
                                <div>
                                    <div>
                                        <Input value={this.state.title}
                                               style={{color: 'black',width:805,marginLeft:5,minWidth:805 }}
                                               onChange={(e) => {
                                                   this.setState({title: e.target.value})
                                               }} placeholder="请输入标题"/>
                                    </div>
                                    <div>
                                        <TextArea value={this.state.summary} style={{marginTop: 20,color:'black',width:805,marginLeft:5,minWidth:805}} onChange={(e) => {
                                            this.setState({summary: e.target.value})
                                        }}  placeholder={'请输入摘要'} rows={4}/>
                                    </div>
                                </div>
                            </div>
                        </td></tr>
                        <tr><td>
                            <div style={{height:"100%"}}>
                                <iframe frameBorder={0} id="editor135"
                                        src={protocol+"//www.135editor.com/pure_editor?callback=true&appkey=contact_135_to_get_your_appkey"}
                                        style={{width: '100%',height:"calc(100vh - 235px)"}}></iframe>
                            </div>
                        </td></tr>
                    </tbody>
                </table>

            </div>
        )
    }

}